// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"3f29fe2c","300":"fe152e3b","463":"4dde3edc","616":"bada1c9c","651":"6b0fd7fe","655":"b2a9ac15","919":"dc8e41fb","960":"d9b807a7","965":"9a89aeae"}[chunkId] + ".chunk.js";
};